import { useState } from "react";
import LoginForm, { LoginFormSubmitHandler } from "../components/LoginForm";
import VercelAuthPage from "../layouts/VercelAuthPage";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import getErrorMessage from "../utils/getErrorMessage";
import { AuthPageProps } from "./Signup";
import { Box, Typography } from "@mui/material";
import Link from "../components/Link";
import { linkVercelAccountViaPasswordLogin } from "../clients/FixieApiClient";
import trackEvent from "../utils/trackEvent";

export default (props: AuthPageProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const vercelCode = searchParams.get('code');
  const vercelConfigurationId = searchParams.get('configurationId');
  const vercelNextUrl = searchParams.get('next');
  const navigate = useNavigate();

  if (!vercelCode || !vercelConfigurationId) {
    toast.error("Vercel code or configuration ID is missing. Redirecting to standard login...");
    navigate('/login');
    return null;
  }

  const onSubmit: LoginFormSubmitHandler = async (data) => {
    if (!isLoading) {
      try {
        setIsLoading(true);
        const response = await linkVercelAccountViaPasswordLogin(data.email, data.password, vercelCode, vercelConfigurationId);
        if (response.status === 200) {
          trackEvent('link_vercel');
          await props.postLoginCallback();
          toast.success("Vercel account connected");
          window.location.href = vercelNextUrl || "/apps";
        } else if (response.status === 205) {
          trackEvent('link_vercel');
          await props.postLoginCallback();
          toast.success("Vercel account connected");
          navigate("/set-password");
        } else {
          const message = await getErrorMessage(response);
          toast.error(
            message || response.status === 401
              ? "Email or password is incorrect"
              : "Something went wrong"
          );
        }
      } catch (error: any) {
        toast.error("Something went wrong");
      } finally {
        setIsLoading(false);
      }
    }
  }
  return (
    <VercelAuthPage>
      <Typography variant="body1">
        Connect your existing <strong>Fixie</strong> account with your <strong>Vercel</strong> account by logging in below
      </Typography>
      <LoginForm onSubmit={onSubmit} isLoading={isLoading} />
      <Box sx={{ textAlign: "center" }}>
        <Typography variant="body2">Don't have a Fixie account? <Link to={`/signup-vercel${window.location.search}`} variant="body2" style={{ textDecoration: "none" }}>Sign up</Link>
        </Typography>
      </Box>
    </VercelAuthPage >
  )
}
